import { REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_ACTIONS_HEADER_ICON_BAR_BREAKPOINTS } from './RequestProfileTabEmailsThreadModalActionsHeader.constants'

export function getVisibleIconsCount(width) {
  if (!width) {
    return REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_ACTIONS_HEADER_ICON_BAR_BREAKPOINTS[0]
      .maxVisibleIcons
  }

  return REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_ACTIONS_HEADER_ICON_BAR_BREAKPOINTS.find(
    ({ minWidth }) => width >= minWidth
  ).maxVisibleIcons
}

export function getVisibleIconBarActions(iconBarActions, width) {
  return iconBarActions.slice(0, getVisibleIconsCount(width))
}

export function getActionsSkeletonCount(width) {
  // visible icon-bar buttons + ActionSelect (kebab) button
  return getVisibleIconsCount(width) + 1
}
